import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import CMMCLayout from "../../components/cmmclayout"
import CMMCSEO from "../../components/cmmcseo"

import "../../style/main.scss"

import CMMCSubNav from "../../components/cmmcsubnav"
import CMMCAbout from "../../components/cmmcabout"
import CMMCSpeakers from "../../components/cmmcspeakers"
import CMMCAgenda from "../../components/cmmcagenda"
import CMMCJoinus from "../../components/cmmcjoinus"
import Location from "../../components/location"



const IndexPage = () => {
  const data = useStaticQuery(graphql`
      query {
        site {
          siteMetadata {
            speakers {
              name
              title
              image
              disabledProfile
              event
            }
            sponsorshipLevel
            sponsors {
              name
              level
              logo
              url
              width
              event
            }
            sessions {
              startTime
              endTime
              title
              description
              type
              speakers {
                name
                isModerator
              }
              event
            }
          }
        }
      }
    `)

  const {
    speakers,
    sessions,
    sponsors,
    sponsorshipLevel
  } = data.site.siteMetadata

  return (
    <CMMCLayout>
      <CMMCSEO title="CMMC Live 2020 | Oct" />
      <CMMCSubNav />
      <CMMCAbout sponsors={sponsors} sponsorshipLevel={sponsorshipLevel} />
      <CMMCSpeakers speakers={speakers} />
      <CMMCAgenda sessions={sessions} speakers={speakers} />
      <CMMCJoinus />
      
    </CMMCLayout>
  )
}

export default IndexPage